<template>
  <div class="register-button-component">
    <big-button href="/register" :main="true" class="cta">Pre-register</big-button>
  </div>
</template>
<script>
  import BigButton from '@/components/BigButton.vue'

  export default {
    name: 'register-button-component',
    components: { BigButton },
  }
</script>

<style lang="scss" scoped>
  .cta {
    display: block;
    width: 220px;
    margin: 30px auto 10px;
    font-size: 22px;
    text-transform: uppercase;
  }
</style>

